import {
  IOwnerTicketInfo,
  IRemoteData,
  ShareStatus
} from "../../../interface/IShareInfo";
import {
  LoadTicketSharingDataActions,
  TicketSharingActionTypes
} from "./actions";

export const initStateTicketShare: IRemoteData<IOwnerTicketInfo> = {
  loading: false,
  data: undefined,
  error: undefined
};

export const ticketShareReducer = (
  state: IRemoteData<IOwnerTicketInfo> = initStateTicketShare,
  action: LoadTicketSharingDataActions
) => {
  switch (action.type) {
    case TicketSharingActionTypes.LOAD_TICKET_SHARING_DATA_PENDING: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }

    case TicketSharingActionTypes.LOAD_TICKET_SHARING_DATA_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    }

    case TicketSharingActionTypes.LOAD_TICKET_SHARING_DATA_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    case TicketSharingActionTypes.SUBMIT_TICKET_SHARING_PENDING: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }

    case TicketSharingActionTypes.SUBMIT_TICKET_SHARING_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          shareStatus: ShareStatus.Requested
        },
        loading: false,
        error: null
      };
    }

    case TicketSharingActionTypes.SUBMIT_TICKET_SHARING_FAILED: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    default: {
      return state;
    }
  }
};
